import {
  EntityIconBase,
  type EntityIconAppearance,
  type EntityIconDensity,
} from './entity-icon-base';
import { Target03Icon } from '@terra/ui-icons';

type IconSignalProps = {
  appearance?: EntityIconAppearance;
  density?: EntityIconDensity;
};

export function IconSignal({ appearance, density }: IconSignalProps) {
  return (
    <EntityIconBase
      icon={Target03Icon}
      bg="bg.entity.signal"
      color="fg.entity.signal"
      borderColor="border.entity.signal"
      appearance={appearance}
      density={density}
    />
  );
}
